import bowser from 'bowser';

export const bowserParser = bowser.getParser(window.navigator.userAgent);
